// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"a80f5673","55":"989e4243","127":"989e4243","263":"989e4243","598":"a80f5673"}[chunkId] + ".chunk.css";
};